import { UserContainer } from "./UserStyles";

function User(props: any) {
  return (
    <UserContainer>
      <img src={props.imageSrc} alt="User" />
      {props.agentName ? <h1>{props.agentName}</h1> : null}
      <h2>{props.name}</h2>
      <h3>{props.rol}</h3>
    </UserContainer>
  );
}

export default User;
